/** Мелкие форматтеры витрины курсов. */

/**
 * Русское склонение по числу: 1 час, 2 часа, 5 часов.
 * Дробные значения (у курса для руководителей модули по 1,5 часа) всегда идут
 * в форму «часа», как того требует русская норма: 1,5 часа, а не 1,5 час.
 */
export const pluralRu = (n, one, few, many) => {
    if (!Number.isInteger(n)) return few;
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
    return many;
};

/** 1.5 -> «1,5», 16 -> «16». В русском тексте дробная часть отделяется запятой. */
export const formatNumber = (n) => String(n).replace('.', ',');

/** 16 -> «16 ак. часов». Короткая форма для карточек и мета-плиток. */
export const hoursLabel = (n) =>
    `${formatNumber(n)} ак. ${pluralRu(n, 'час', 'часа', 'часов')}`;

/** 16 -> «16 академических часов». Развёрнутая форма для сводки под заголовком. */
export const hoursLabelFull = (n) =>
    `${formatNumber(n)} ${pluralRu(n, 'академический час', 'академических часа', 'академических часов')}`;

/**
 * «16 ак. часов · 2 дня», а при незаполненной второй части — просто «16 ак. часов».
 * У половины курсов в документах указаны только часы, и без этой проверки
 * на витрине оставался висящий разделитель.
 */
export const durationLabel = (hours, shape) => {
    const base = hoursLabel(hours);
    const tail = (shape || '').trim();
    return tail ? `${base} · ${tail}` : base;
};

/** 12 -> «12 программ». */
export const programsLabel = (n) =>
    `${n} ${pluralRu(n, 'программа', 'программы', 'программ')}`;

/** Цена в тенге с разделителями разрядов. Показывается, только если SHOW_PRICES. */
export const priceLabel = (tenge) =>
    `${String(tenge).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₸`;
